export const accountsAbsoluteBaseUrl = process.env.NEXT_PUBLIC_ACCOUNTS_BASE_URL || '';
export const cloudAbsoluteBaseUrl = process.env.NEXT_PUBLIC_CLOUD_BASE_URL || '';
export const docsAbsoluteBaseUrl = process.env.NEXT_PUBLIC_DOCS_BASE_URL || '';
export const hubAbsoluteBaseUrl = process.env.NEXT_PUBLIC_HUB_BASE_URL || '';
export const websiteAbsoluteBaseUrl = process.env.NEXT_PUBLIC_WEBSITE_BASE_URL || '';
export const accountsBaseUrl = process.env.APP_NAME === 'accounts' ? '' : accountsAbsoluteBaseUrl;
export const cloudBaseUrl = process.env.APP_NAME === 'cloud' ? '' : cloudAbsoluteBaseUrl;
export const docsBaseUrl = docsAbsoluteBaseUrl;
export const hubBaseUrl = process.env.APP_NAME === 'hub' ? '' : hubAbsoluteBaseUrl;
export const websiteBaseUrl = process.env.APP_NAME === 'website' ? '' : websiteAbsoluteBaseUrl;
